import {Component, Input} from '@angular/core';
import {FormControl, Validators} from '@angular/forms';
import {isValidIp} from '../../infra/ip.validator';

@Component({
    selector: 'af-ip-input',
    templateUrl: './ip-input.component.html',
    styleUrl: './ip-input.component.scss',
    standalone: false,
})
export class IpInputComponent {
    @Input() control: FormControl<string>;
    @Input() label: string;
    @Input() placeholder = 'IP';
    @Input() name = 'ip';

    Validators = Validators;
    isValidIp = isValidIp;
}
